module.exports = __webpack_public_path__ + "img/audi-toggle.2f184275.gif";